import { Injectable, inject } from '@angular/core';
import { HttpService } from './http.service';

@Injectable({
    providedIn: 'root'
})
export class LicenseService {
    private http = inject(HttpService);



    getCrispKey() {
        return this.http.gql_query('query { get_crisp_key {key}}', {});
    }

    getClientLicenseSites(client_uniq: string, role: string) {
        const query = `query($client_uniq: String!) {
      client(uniq: $client_uniq) {
        id,
        sites {
          id,
          uniq,
          name,
          address,
          city,
          postcode,
          phone,
          description,
          color,
          language_default,
          lang_receipt,
          shop_type,
          pos_id,
          pos_system,
          delivery_options {
            id
            by_meters
            by_cities
            by_postal_codes
            meters
            meters_2
            meters_3
            meters_4
            delivery_price
            delivery_price_2
            delivery_price_3
            delivery_price_4
            delivery_free_basket
            delivery_free_basket_2
            delivery_free_basket_3
            delivery_free_basket_4
            delivery_min_basket
            delivery_min_basket_2
            delivery_min_basket_3
            delivery_min_basket_4
            delivery_min_time
            delivery_min_time_2
            delivery_min_time_3
            delivery_min_time_4
            with_zone_2
            with_zone_3
            with_zone_4
            cities {
              city
              place_id
            }
            postal_codes {
              postal_code
              place_id
            }
          },
          license {
            id,
            site_id,
            subscription_id,
            type,
            init_payment_status,
            delivery,
            base_amount,
            discount,
            discount_comment,
            discount_amount,
            init_payment_discount_amount,
            amount,
            currency,
            yearly,
            start,
            trial_period_days,
            end,
            device,
            photo,
            kit_com,
            production,
            hardware,
            hardware_quantity,
            marketing,
            marketing_360,
            marketing_360_monthly,
            biding,
            deliveree,
            deliveree_pro,
            active_for_app,
            active_for_storefront,
            active_for_pos,
            active_for_kiosk,
            kiosk_device_limit,
            pos_device_limit,
            white_label,
            priority_support,
            sms_package,
            bundle_discount_percent
          }
        }
      }
    }`;
        return this.http.gql_query(query, { client_uniq }, role);
    }

    getCitiesAutoComplete(cityQuery: string) {
        return this.http.get('/delivery/city/' + cityQuery, 'ADMIN', true);
    }

    getPostalCodesAutoComplete(postalCodeQuery: string) {
        return this.http.get('/delivery/postal_code/' + postalCodeQuery, 'ADMIN', true);
    }

    saveLicense(item: any) {
        // Finalize license simulation/order
        // Map licenses to include all required fields for backend
        const licensesWithSiteId = (item.licenses || []).map((lic: any) => ({
            ...lic,
            // Ensure site_id is present (required for backend to find/update)
            site_id: lic.site_id || lic.siteId,
            // Ensure boolean fields are actual booleans
            active_for_app: lic.active_for_app ?? true,
            active_for_storefront: lic.active_for_storefront ?? true,
            active_for_pos: lic.active_for_pos ?? true,
            active_for_kiosk: lic.active_for_kiosk ?? false,
            // Explicit null = "no cap"; the backend distinguishes null from absent.
            kiosk_device_limit: lic.kiosk_device_limit ?? null,
            pos_device_limit: lic.pos_device_limit ?? null,
            white_label: !!lic.white_label,
            priority_support: !!lic.priority_support,
            hardware: (lic.hardware_quantity || 0) > 0 || !!lic.hardware,
            // Numeric fields
            sms_package: lic.sms_package || 0,
            device: lic.device || 0,
            hardware_quantity: lic.hardware_quantity || 0,
        }));

        const form = {
            client: {
                licenses: licensesWithSiteId,
                currency: item.currency,
                sass: item.sass
            }
        };
        return this.http.save("/shop/client", form, item.uniq, "", "", "ADMIN");
    }
}
